import { StyledAnnouncementContainer, StyledAnnouncementContent } from './styles';

export function AnnouncementBar() {
  return (
    <StyledAnnouncementContainer>
      <StyledAnnouncementContent>Your handmade itinerary is valid for 46 more days</StyledAnnouncementContent>
    </StyledAnnouncementContainer>
  );
}
